import { useContext, useMemo } from 'react';
import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import { ExpandLessIcon, ExpandMoreIcon } from '@atom/mui/icons';
import { SchemaAttributeGroup } from '@atom/types/schema';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import CreateAssetModalContext from '../CreateAssetModalContext';

import classes from './attributesTab.module.css';

interface Props {
  attributeGroup: SchemaAttributeGroup;
}

const AttributeGroupRow = ({ attributeGroup }: Props) => {
  const { collapsedGroups, setCollapsedGroups, errorAttributeIds } = useContext(
    CreateAssetModalContext,
  );

  const handleToggle = () => {
    setCollapsedGroups(toggleFromSet(collapsedGroups, attributeGroup?.id));
  };

  const hasErrorAttributes = useMemo(() => {
    const matchingAttributes = attributeGroup.attributes.map(attributeId => {
      return errorAttributeIds.has(attributeId);
    });

    return R.any(R.equals(true), matchingAttributes);
  }, [attributeGroup, errorAttributeIds]);

  const icon = collapsedGroups.has(attributeGroup?.id)
    ? ExpandLessIcon
    : ExpandMoreIcon;

  return (
    <div className={classes.attributeGroupRow}>
      <div className={classes.attributeGroupTitle}>{attributeGroup.name}</div>
      <div className={classes.actionContainer}>
        {hasErrorAttributes && <div>Please fill out the required fields</div>}
        <IconButton
          onClick={handleToggle}
          edge="end"
          data-cy={`createAssetAttributeGroupToggle-${attributeGroup.name}`}
        >
          <Icon icon={icon} />
        </IconButton>
      </div>
    </div>
  );
};

export default AttributeGroupRow;
